import { render, staticRenderFns } from "./PagamentoAnexoDownload.vue?vue&type=template&id=099f45a7"
import script from "./PagamentoAnexoDownload.vue?vue&type=script&lang=js"
export * from "./PagamentoAnexoDownload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports